import Vue from 'vue'
import Chat from './components/chat'

// 3rd Party Libs
import './libs/composition-api'

import './globalComponents'

import store from './store'

import AppHeader from './layout/header'
import AppHeaderMobile from './layout/header-mobile'
import AppFooter from './layout/footer'
import Page from './layout/page'

import FirstVisit from './components/first-visit'
import InterestBar from './components/interest-bar'
import NewsletterPopup from './components/newsletter-popup'
import ContactPanel from './components/ContactPanel.vue'

Vue.use(Chat)

// Globa Path for webpack chunks
// eslint-disable-next-line camelcase
__webpack_public_path__ = argus_url.webpack_pub

new Vue({
  name: 'Argus',
  delimiters: ['${', '}'],
  store,
  components: {
    Page,
    AppHeader,
    AppHeaderMobile,
    AppFooter,
    FirstVisit,
    InterestBar,
    NewsletterPopup,
    ContactPanel,
  },
}).$mount('#app')
